<script>
	import GameTitle from "./GameTitle.svelte";
	import HeaderMenu from "./components/HeaderMenu.svelte";

	import { fade } from "svelte/transition";
	import { onMount } from "svelte";
	import { ST_gamestart, ST_gameend } from "./stores.js";
	import { get } from "svelte/store";
import GameEnd from "./GameEnd.svelte";

	let isVisible = false;
	onMount(() => {
		isVisible = true;
	});

	let gameStart = get(ST_gamestart);
	ST_gamestart.subscribe((value) => {
		gameStart = value;
	});

	let gameEnd= get(ST_gameend);
	ST_gameend.subscribe((value) => {
		gameEnd = value;
	});
</script>

{#if isVisible}
	{#if gameStart || gameEnd}
		<HeaderMenu />
	{/if}
	<div transition:fade={{ delay: 500 }}>
		<section class="hero is-warning is-fullheight">
			<div class="hero-body">
				<GameTitle />
			</div>
		</section>
	</div>
{/if}
